/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { ConsoleBaseInstance } from '../Base/ConsoleBaseInstance.entity';
import {
  CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_FULL,
  CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_LIMITED,
} from './ConsoleConnectInstance.entity.constant';

export type EntityConsoleConnectInstance = io.TypeOf<typeof ConsoleConnectInstance>;

export const ConsoleConnectInstance = io.intersection([
  ConsoleBaseInstance,
  io.type({
    connectContractId: io.string,
    connectWorkspaceId: io.string,
    connectWorkspaceType: io.union([
      io.literal(CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_LIMITED),
      io.literal(CONSOLE_INSTANCE_CONNECT_WORKSPACE_TYPE_FULL),
    ]),
    connectWorkspaceUrl: io.string,
    connectWorkspaceUrlSso: io.string,
  }),
]);
